export default "__VITE_ASSET__BJR2e$46__"